module.exports = __webpack_public_path__ + "img/smokegrenade_impact.9181e607.svg";